import { queryOptions } from '@tanstack/react-query';
import { getUserProfile, getUserProfileDetails, getUserProfileRepresentative } from './api/backend/profile';
import { getRegistryItemDetails as getRegistryItem } from './api/backend/registry';
import { getProcessInstance } from './api/backend/workflow';
import { ApiError, ProcessInstanceType } from './api/backend/types';

export const userProfilesQueryOptions = () =>
  queryOptions({
    queryKey: ['userProfile'],
    queryFn: () => getUserProfile(),
  });

export const processInstanceQueryOptions = (
  processInstanceId: string,
  navigatedFrom?: string,
  ignoreStatusCodes?: number[],
) =>
  queryOptions<ProcessInstanceType, ApiError>({
    queryKey: ['processInstance', { processInstanceId, navigatedFrom, ignoreStatusCodes }],
    queryFn: () => getProcessInstance(processInstanceId, navigatedFrom, ignoreStatusCodes),
  });

export const userProfileDetailsQueryOptions = (id: string) =>
  queryOptions({
    queryKey: ['userProfileDetails', id],
    queryFn: getUserProfileDetails,
  });

export const userProfileRepresentativeQueryOptions = (id: string) =>
  queryOptions({
    queryKey: ['userProfileRepresentative', id],
    queryFn: () => getUserProfileRepresentative(id),
  });

export const registryItemQueryOptions = (id: string, version?: string) =>
  queryOptions({
    queryKey: ['registryItemDetails', id, version],
    queryFn: () => getRegistryItem(id, version),
  });
